export const WEB_URL = 'web-url';
export const PERCENT = 'percent';
export const PHONE_NUMBER = 'phone-number';
export const TIMESTAMP = 'timestamp';
export const DATE = 'date';
export const IMAGE_URL = 'image-url';
export const HIDDEN = 'hidden';
export const WEIGHT = 'weight';
export const HEIGHT = 'height';
export const DATA_LINK = 'data-link';
export const ACTIONABLE_BUTTON = 'actionable-button';
export const PREFORMATTED = 'pre';
export const WEB_PROXY = 'web-proxy';
export const AUDIO_URL = 'audio-url';
